module.exports = __webpack_public_path__ + "assets/images/bagarrow-off.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/bagarrow-off.png
// module id = 398
// module chunks = 1